module.exports = __webpack_public_path__ + "static/media/logo-yaracuy.b6943088.png";